export const extend = ({ theme }) => ({
    animationSite: {
        display: 'flex',
        alignItems: 'center',
        '& .Link-button': {
            marginTop: '2rem',
        },
    },
});
